<template>
  <div>
      <!-- <slot v-bind="pageinfo" name="title"><p>如果父节点没有替换内容，你将看到此消息。</p></slot>
      <slot v-bind="pageinfo"><p>如果父节点没有替换内容，你将看到此消息。</p></slot> -->
        <el-table
        :data="chengshu_results"
        style="width: 100%">
            <!-- <el-table-column prop="id" label="序号" min-width="5%"></el-table-column> -->
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="assessee" label="被评估人" min-width="12%"></el-table-column>
            <el-table-column prop="email" label="邮箱" min-width="20%"></el-table-column>
            <el-table-column prop="company" label="公司" min-width="14%"></el-table-column>
            <el-table-column prop="department" label="部门" min-width="14%"></el-table-column>
            <el-table-column prop="superior" label="上级主管" min-width="12%"></el-table-column>
            <!-- <el-table-column prop="cultural" label="文化价值观" min-width="20%"></el-table-column> -->
            <el-table-column prop="score" label="测评得分" min-width="12%"></el-table-column>
            <el-table-column prop="operations" label="操作" min-width="16%">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="primary" 
                    @click="view_details(scope.row)">查看详情</el-button>
                    <el-dialog title="" :visible.sync="dialogFormVisible" width="800px" :destroy-on-close="true" :close-on-click-modal="false">
                        <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
                        <template slot="title">
                            <span style="font-weight:bold;font-size:18px;">管理基本功评估</span>
                            <span style="font-weight:bold;font-size:16px;"> (被评估人：</span>
                            <span style="font-weight:bold;font-size:16px;color:#409EFF;">{{ form.assessee }}</span>
                            <span style="font-weight:bold;font-size:16px;"> /评估得分：</span>
                            <span style="font-weight:bold;font-size:16px;color:#409EFF;">{{ form.score }})</span>
                        </template>
                        <!-- 这里通过sendData监听子组件的$emit方法，并通过父组件的getData方法获取子组件传递的数据 -->
                        <view-details ref="view_details" :score_detail="score_detail"></view-details>
                        <div style="text-align:center;margin-top:20px;">
                            <el-button type="primary" @click="dialogClose">关闭</el-button>
                        </div>
                    </el-dialog>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin-top:10px;" v-if="chengshu_results.length > 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageinfo.count"
                :page-sizes="pageinfo.page_sizes"
                :page-size="pageinfo.page_size"
                layout="total, sizes, prev, pager, next"
                :total="pageinfo.count">
            </el-pagination>
        </div>
  </div>
</template>

<script>
import getdata from "@/api/getData.js";
import viewDetails from "./ViewDetails.vue";
export default {
    created() {
        this.get_results();
    },
    components: {
        viewDetails,
    },
    data() {
        return {
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 10,
                page_sizes: [1, 10, 20, 50, 100],
            },
            chengshu_results: [],
            // full_results: [
            //     {
            //         assessee: '张三',
            //         company: '',
            //         department: '部门A',
            //         superior: '赵六',
            //         // cultural: 'A 文化价值楷模',
            //         score: '-',
            //     },{
            //         assessee: '李四',
            //         company: '',
            //         department: '部门B',
            //         superior: '王五',
            //         // cultural: 'Y 符合文化价值观',
            //         score: '-',
            //     }
            // ],
            // tmp_table: [
            //     {
            //         assessee: '搜索的张三',
            //         company: '',
            //         department: '搜索的部门A',
            //         superior: '搜索的赵六',
            //         // cultural: 'A 文化价值楷模',
            //         score: '-',
            //     }
            // ],
            form: {},
            dialogFormVisible: false,
            score_detail: [],
        };
    },
    props: ['query_info', 'task_id'],
    methods: {
        view_details(row) {
            // 如果是查询详情，则需要使用被评估人id和任务id，从后台获取评估结果进行展示
            this.getDetailsByUser(row.assessee_id);
            this.form = row;
            this.dialogFormVisible = true;
        },
        dialogClose() {
            this.dialogFormVisible = false;
        },
        getDetailsByUser(id) {
            let params;
            params = {
                'assessee_id': id,
                'task_id': this.task_id,
            }
            getdata.getListP("getScoreDetails", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.score_detail = resp.data.data;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('query_info: ' + this.query_info);
            if(this.query_info==''){
                this.get_results();
            }else{
                this.get_results(this.query_info);
            }
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('query_info: ' + this.query_info);
            if(this.query_info==''){
                this.get_results();
            }else{
                this.get_results(this.query_info);
            }
        },
        get_results(query_info) {
            // 同时用于全量获取和按照条件查询时获取结果信息，query_info为空表示全量查询
            query_info = query_info||'';
            let params;
            params = {
                query_info: query_info,
                task_id: this.task_id,
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
            }
            getdata.getListP("getResults", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.chengshu_results = resp.data.data;
                        this.pageinfo.count = resp.data.count;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        refresh_results() {
            let params;
            params = {
                task_id: this.task_id,
            }
            getdata.getListP("updateResults", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.$message({
                            message: '结果刷新成功！',
                            type: 'success',
                            duration: 1500,
                        })
                        // this.chengshu_results = resp.data.data;
                        // this.pageinfo.count = resp.data.count;
                        // 这里换成只通过接口让后台更新结果数据，前台页面数据的获取还是直接使用单独获取数据的接口（便于搜索和分页的处理）
                        if(this.query_info==''){
                            this.get_results();
                        }else{
                            this.get_results(this.query_info);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>

<style scoped>
::v-deep .el-form-item {
    margin-bottom: 0;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* .search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
} */
</style>